import { ThreeDots } from "react-loader-spinner";

const Card = (props) => {
  return (
    <div onClick={props.navigate} className={props.size}>
      <div className={props.class}>
        <div className="stats-icon stats-icon-lg">{props.icon}</div>
        <div className="stats-content">
          <div className="stats-title">{props.title}</div>
          {props.value ? (
            <div className="stats-number">{props.value}</div>
          ) : (
            <ThreeDots
              visible={true}
              height="50"
              width="80"
              color="#fff"
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          )}

          <div className="stats-title pb-3">{props.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
